"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = {
    name: "radio",
    isImplicit: true,
    errorMessage: "You should select one of the options.",
    validate: function (value) { return !!value; },
};
